import { shallowMount, createLocalVue } from '@vue/test-utils';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import ReturnCustomer from './ReturnCustomer';

const localVue = createLocalVue();
localVue.use(VueRouter);
localVue.use(Vuex);

const router = new VueRouter();

describe('ReturnCustomer', () => {
  let wrapper;
  let store;
  let getRecentInvoicesMock;
  let initSubscriptionsMock;
  let initBoostRecommendationsMock;
  let initMembershipXsellProductsMock;

  beforeEach(() => {
    getRecentInvoicesMock = jest.fn();
    initSubscriptionsMock = jest.fn();
    initBoostRecommendationsMock = jest.fn();
    initMembershipXsellProductsMock = jest.fn();

    store = new Vuex.Store({
      modules: {
        customer: {
          namespaced: true,
          state: {
            cdata: {},
            recentInvoices: []
          },
          getters: {
            isColorSubscriber: jest.fn(),
            subscribeAndSaveProduct: jest.fn(),
            colorSatisfactionInvoice: jest.fn().mockReturnValueOnce({})
          },
          actions: {
            getRecentInvoices: getRecentInvoicesMock
          }
        },
        subscriptions: {
          namespaced: true,
          state: {},
          getters: {
            nextSubShipment: jest.fn()
          },
          actions: {
            initSubscriptions: initSubscriptionsMock
          }
        },

        refillCart: {
          namespaced: true,
          state: {
            refillCart: {}
          }
        },

        xsell: {
          namespaced: true,
          state: {
            boostRecommendations: []
          },
          actions: {
            initBoostRecommendations: initBoostRecommendationsMock,
            initMembershipXsellProducts: initMembershipXsellProductsMock
          }
        }
      }
    });

    wrapper = shallowMount(ReturnCustomer, {
      store,
      localVue,
      router
    });
  });

  afterEach(() => {
    getRecentInvoicesMock.mockClear();
    initSubscriptionsMock.mockClear();
    initMembershipXsellProductsMock.mockClear();
  });

  test('snapshot', () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('computed', () => {
    describe('showColorSatisfaction', () => {

      test('return false when colorSatisfactionInvoice is an empty obj', () => {
        let localThis = { colorSatisfactionInvoice: {} };
        expect(ReturnCustomer.computed.showColorSatisfaction.call(localThis)).toEqual(false);
      });

      test('return false when colorSatisfactionInvoice has id but does not have product.id', () => {
        let localThis = { colorSatisfactionInvoice: { id: 12345, product: {} } };
        expect(ReturnCustomer.computed.showColorSatisfaction.call(localThis)).toEqual(false);
      });

      test('return true when colorSatisfactionInvoice has id and product.id', () => {
        let localThis = { colorSatisfactionInvoice: { id: 12345, product: { id: 23 } } };
        expect(ReturnCustomer.computed.showColorSatisfaction.call(localThis)).toEqual(true);
      });

    });
  });

});
